import React, { useMemo } from 'react';
import { calcularTVP } from './utils';

const RutasCriticas = ({ datos }) => {
    const tvpRutas = useMemo(() => calcularTVP(datos, 'RUTA').slice(0, 5), [datos]);

    return (
        <section className="ev-seccion">
            <h3 className="ev-seccion-titulo">
                <i className="pi pi-map" /> RUTAS CRÍTICAS — TVP
            </h3>
            <div className="ev-tvp-lista">
                {tvpRutas.map((item) => {
                    const velColor = item.velocidadMax >= 100 ? '#ef4444' : '#f97316';
                    return (
                        <div key={item.nombre} className="ev-tvp-item">
                            <div className="ev-tvp-nombre">{item.nombre}</div>
                            <div className="ev-tvp-chips">
                                <span className="ev-chip ev-chip-total">
                                    <i className="pi pi-list" /> {item.total} excesos
                                </span>
                                <span className="ev-chip" style={{ background: velColor + '22', color: velColor, border: `1px solid ${velColor}55` }}>
                                    <i className="pi pi-bolt" /> {item.velocidadMax} km/h máx.
                                </span>
                                <span className="ev-chip ev-chip-prom">
                                    <i className="pi pi-gauge" /> {item.promedio} km/h prom.
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>
        </section>
    );
};

export default RutasCriticas;
